var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    fill: "none"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#485156",
    fillRule: "evenodd",
    d: "m3.061 10 8.47-8.47L10.47.47l-9 9L.94 10l.53.53 9 9 1.06-1.06z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;